<template>
  <v-dialog v-model="isActive">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-on="on"
        v-bind="attrs"
        color="primary"
        class="mx-2"
        icon small
      >
        <v-icon class="cursor-pointer">mdi-pencil</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">統計資料控制</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="名稱"
                class="rounded-lg"
                v-model="name"
                dense
                outlined
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="間隔"
                class="rounded-lg"
                v-model="interval"
                dense
                outlined
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                label="上次更新"
                class="rounded-lg"
                :value="statistic.last_update"
                dense
                outlined
                hide-details
                readonly
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                label="下次更新"
                class="rounded-lg"
                v-model="exp_time"
                dense
                outlined
                hide-details
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                label="執行時間"
                class="rounded-lg heat"
                :value="statistic.during + ' ms'"
                :style="`--val: ${statistic.during < 600 ? statistic.during / 5 : 120}`"
                dense
                outlined
                hide-details
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                label="說明"
                class="rounded-lg"
                v-model="comment"
                dense
                outlined
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                label="sql"
                class="rounded-lg"
                v-model="sql"
                dense
                outlined
                hide-details
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-tabs vertical>
                <v-tab>
                  Value
                </v-tab>
                <v-tab :class="{ 'error--text': statistic.error }">
                  Error
                </v-tab>
                <v-tab-item>
                  <v-card flat>
                    <v-card-text
                      :style="{ 'white-space': 'pre-wrap', overflow: 'auto', 'height': '300px' }"
                    >
                      {{ JSON.parse(statistic.value, null, 2) }}
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card flat>
                    <v-card-text
                      :style="{ 'white-space': 'pre-wrap', overflow: 'auto', 'height': '300px' }"
                    >
                      {{ statistic.error }}
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-switch id="clearError" v-model="clearError" label="清除錯誤" small></v-switch> 
        <v-spacer></v-spacer>
        <v-btn class="dialogbtn cancelBtnColor" @click="close">關閉</v-btn>
        <v-btn class="dialogbtn subBtnColor" @click="confirm">送出</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['statistic'],
  data() {
    return {
      isActive: false,
      name: this.statistic.name,
      interval: this.statistic.interval,
      comment: this.statistic.comment,
      sql: this.statistic.sql,
      exp_time: this.statistic.exp_time,
      clearError: false
    }
  },
  methods: {
    confirm() {
      this.$emit('update',
        Object.assign({}, this.statistic, {
          name: this.name,
          interval: this.interval,
          comment: this.comment,
          sql: this.sql, 
          exp_time: this.exp_time,
          error: this.clearError ? null : this.statistic.error
        })),
      this.isActive = false
    },
    close() {
      this.name = this.statistic.name
      this.interval = this.statistic.interval
      this.comment = this.statistic.comment
      this.sql = this.statistic.sql 
      this.exp_time = this.statistic.exp_time

      this.isActive = false
    }
  }
}
</script>

<style scoped>
.heat {
  color: hsl(calc(120 - (var(--val) * 1.2)), 75%, 40%) !important;
  font-weight: 600;
  transition: color 200ms ease;
}
</style>
